module.exports = __webpack_public_path__ + "media/application/images/2023/05_still-1920x1080-2de0a2086598a093b70db1e82d45c9b8.png";